import React from 'react';
import restaurantData from './hotelData';
import { faStar } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './Hotels.css';

const Hotels = ({ search }) => {



  return (
    <div className="container">
      <div className="row">
        <div className="heading-hotel">
          <h2 className="title-hotel pt-4 pb-3">
            Trending Italian Recipes
          </h2>
        </div>
        {
          restaurantData.map((hotels, index) => <div className="container col-4 hotel-box p-0" key={index}>
            <img src={hotels.img} alt="" />
            <div className="hotel-name mt-4 d-flex align-items-center justify-content-around ">
              <h4 className="name-0f-hotel  d-inline">
                {hotels.title}
              </h4>
              <p className='location-hotel'>{hotels.location}</p>
              <p className="rating d-inline  ">
                {hotels.rating}<FontAwesomeIcon className="icon-star" icon={faStar} />
              </p>
            </div>
            <div className="type-of-hotel mb-4 mt-2 d-flex align-items-center justify-content-around ">
              <p className="d-inline">
                {hotels.maintitle}
              </p>
              <p className="d-inline mb-4  ">
                {hotels.price} for two
              </p>
            </div>
          </div>
          )}
      </div>
    </div>
  );
};

export default Hotels;
